export default "__VITE_ASSET__Cw3HYtX0__"